"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionPaperKindHistoryItem = exports.SectionFooterOffsetHistoryItem = exports.SectionHeaderOffsetHistoryItem = exports.SectionDifferentFirstPageHistoryItem = exports.SectionLandscapeHistoryItem = exports.SectionStartTypeHistoryItem = exports.SectionPageHeightHistoryItem = exports.SectionPageWidthHistoryItem = exports.SectionColumnsInfoHistoryItem = exports.SectionEqualWidthColumnsHistoryItem = exports.SectionSpaceHistoryItem = exports.SectionColumnCountHistoryItem = exports.SectionMarginBottomHistoryItem = exports.SectionMarginRightHistoryItem = exports.SectionMarginTopHistoryItem = exports.SectionMarginLeftHistoryItem = exports.SectionPropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../base/history-item");
var SectionPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(SectionPropertiesHistoryItemBase, _super);
    function SectionPropertiesHistoryItemBase(modelManipulator, interval, newValue) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.newValue = newValue;
        _this.interval = interval;
        return _this;
    }
    SectionPropertiesHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getPropertiesManipulator().setValue(this.interval, this.newValue);
    };
    SectionPropertiesHistoryItemBase.prototype.undo = function () {
        this.getPropertiesManipulator().restoreValue(this.oldState);
    };
    return SectionPropertiesHistoryItemBase;
}(history_item_1.HistoryItem));
exports.SectionPropertiesHistoryItemBase = SectionPropertiesHistoryItemBase;
var SectionMarginLeftHistoryItem = (function (_super) {
    tslib_1.__extends(SectionMarginLeftHistoryItem, _super);
    function SectionMarginLeftHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionMarginLeftHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.marginLeft;
    };
    return SectionMarginLeftHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionMarginLeftHistoryItem = SectionMarginLeftHistoryItem;
var SectionMarginTopHistoryItem = (function (_super) {
    tslib_1.__extends(SectionMarginTopHistoryItem, _super);
    function SectionMarginTopHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionMarginTopHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.marginTop;
    };
    return SectionMarginTopHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionMarginTopHistoryItem = SectionMarginTopHistoryItem;
var SectionMarginRightHistoryItem = (function (_super) {
    tslib_1.__extends(SectionMarginRightHistoryItem, _super);
    function SectionMarginRightHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionMarginRightHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.marginRight;
    };
    return SectionMarginRightHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionMarginRightHistoryItem = SectionMarginRightHistoryItem;
var SectionMarginBottomHistoryItem = (function (_super) {
    tslib_1.__extends(SectionMarginBottomHistoryItem, _super);
    function SectionMarginBottomHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionMarginBottomHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.marginBottom;
    };
    return SectionMarginBottomHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionMarginBottomHistoryItem = SectionMarginBottomHistoryItem;
var SectionColumnCountHistoryItem = (function (_super) {
    tslib_1.__extends(SectionColumnCountHistoryItem, _super);
    function SectionColumnCountHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionColumnCountHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.columnCount;
    };
    return SectionColumnCountHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionColumnCountHistoryItem = SectionColumnCountHistoryItem;
var SectionSpaceHistoryItem = (function (_super) {
    tslib_1.__extends(SectionSpaceHistoryItem, _super);
    function SectionSpaceHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionSpaceHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.space;
    };
    return SectionSpaceHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionSpaceHistoryItem = SectionSpaceHistoryItem;
var SectionEqualWidthColumnsHistoryItem = (function (_super) {
    tslib_1.__extends(SectionEqualWidthColumnsHistoryItem, _super);
    function SectionEqualWidthColumnsHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionEqualWidthColumnsHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.equalWidthColumns;
    };
    return SectionEqualWidthColumnsHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionEqualWidthColumnsHistoryItem = SectionEqualWidthColumnsHistoryItem;
var SectionColumnsInfoHistoryItem = (function (_super) {
    tslib_1.__extends(SectionColumnsInfoHistoryItem, _super);
    function SectionColumnsInfoHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionColumnsInfoHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.columnsInfo;
    };
    return SectionColumnsInfoHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionColumnsInfoHistoryItem = SectionColumnsInfoHistoryItem;
var SectionPageWidthHistoryItem = (function (_super) {
    tslib_1.__extends(SectionPageWidthHistoryItem, _super);
    function SectionPageWidthHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionPageWidthHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.pageWidth;
    };
    return SectionPageWidthHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionPageWidthHistoryItem = SectionPageWidthHistoryItem;
var SectionPageHeightHistoryItem = (function (_super) {
    tslib_1.__extends(SectionPageHeightHistoryItem, _super);
    function SectionPageHeightHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionPageHeightHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.pageHeight;
    };
    return SectionPageHeightHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionPageHeightHistoryItem = SectionPageHeightHistoryItem;
var SectionStartTypeHistoryItem = (function (_super) {
    tslib_1.__extends(SectionStartTypeHistoryItem, _super);
    function SectionStartTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionStartTypeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.startType;
    };
    return SectionStartTypeHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionStartTypeHistoryItem = SectionStartTypeHistoryItem;
var SectionLandscapeHistoryItem = (function (_super) {
    tslib_1.__extends(SectionLandscapeHistoryItem, _super);
    function SectionLandscapeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionLandscapeHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.landscape;
    };
    return SectionLandscapeHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionLandscapeHistoryItem = SectionLandscapeHistoryItem;
var SectionDifferentFirstPageHistoryItem = (function (_super) {
    tslib_1.__extends(SectionDifferentFirstPageHistoryItem, _super);
    function SectionDifferentFirstPageHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionDifferentFirstPageHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.differentFirstPage;
    };
    return SectionDifferentFirstPageHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionDifferentFirstPageHistoryItem = SectionDifferentFirstPageHistoryItem;
var SectionHeaderOffsetHistoryItem = (function (_super) {
    tslib_1.__extends(SectionHeaderOffsetHistoryItem, _super);
    function SectionHeaderOffsetHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionHeaderOffsetHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.headerOffset;
    };
    return SectionHeaderOffsetHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionHeaderOffsetHistoryItem = SectionHeaderOffsetHistoryItem;
var SectionFooterOffsetHistoryItem = (function (_super) {
    tslib_1.__extends(SectionFooterOffsetHistoryItem, _super);
    function SectionFooterOffsetHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionFooterOffsetHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.footerOffset;
    };
    return SectionFooterOffsetHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionFooterOffsetHistoryItem = SectionFooterOffsetHistoryItem;
var SectionPaperKindHistoryItem = (function (_super) {
    tslib_1.__extends(SectionPaperKindHistoryItem, _super);
    function SectionPaperKindHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionPaperKindHistoryItem.prototype.getPropertiesManipulator = function () {
        return this.modelManipulator.sectionProperties.paperKind;
    };
    return SectionPaperKindHistoryItem;
}(SectionPropertiesHistoryItemBase));
exports.SectionPaperKindHistoryItem = SectionPaperKindHistoryItem;
